import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { useState, useCallback, useEffect } from "react";
import { useGetLessonSubjectQuery } from "../../../api/lessonNoteApi";
import api from "../../../services/CBT";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const EditSetUp = ({ onSuccess, item }) => {
  const [setTypes, setSetTypes] = useState([])
  const { data: lessonSubject = [] } = useGetLessonSubjectQuery();
  const { admToken, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [subjectLoading, setSubjectLoading] = useState(false);
  const [setupData, setSetupData] = useState(null);
  const [formData, setFormData] = useState({
    subjectId: item?.subjectId,
    quizTypeId: 0,
    startDate: item?.startDate,
    endDate: item?.endDate,
    title: item?.title,
    duration: item?.duration,
    score: item?.score,
    ismultipleAttemp: item?.ismultipleAttemp,
    assignClasses: [
      {
        classId: 0,
        className: ''
      }
    ]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value)
    setFormData(prev => ({
      ...prev,
      [name]: name === "quizTypeId" || name === "subjectId" ? parseInt(value, 10) : value
    }));
  };


  const getDataCTBSetup = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getCBTSetUp(admToken, user.schoolId);
      if (res.status && res.statusCode === 2) {
        setSetupData(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      toast.error("Failed to fetch setup data");
    }
  }, [admToken]);

  const getDataCTBTypes = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getTypes(admToken);
      if (res.status && res.statusCode === 2) {
        setSetTypes(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      toast.error("Failed to fetch quiz types");
    }
  }, [admToken]);

  useEffect(() => {
    getDataCTBTypes();
    if (item) {
      setFormData({
        subjectId: item.subjectId || "",
        quizTypeId: "",
        startDate: item.startDate || "",
        endDate: item.endDate || "",
        score: item.score || "",
        ismultipleAttemp: item.ismultipleAttemp || false,
        title: item.title || "",
        duration: item.duration || "",
        assignClasses: item.assignClasses || [
          {
            classId: 0,
            className: ''
          }
        ]
      });
    }
  }, [item]);

  useEffect(() => {
    if (setTypes.length > 0 && item?.quizType) {
      const matchedType = setTypes.find((type) => type.name === item.quizType);
      if (matchedType) {
        setFormData((prev) => ({
          ...prev,
          quizTypeId: matchedType.id,
        }));
      }
    }
  }, [setTypes, item?.quizType]);

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      const payload = {
        postedDate: item?.postedDate,
        postedBy: item?.postedBy,
        title: formData.title,
        quizType: item?.quizType,
        subject: item?.subject,
        startDate: new Date(formData.startDate).toISOString(),
        endDate: new Date(formData.endDate).toISOString(),
        duration: parseInt(formData.duration),
        subjectId: parseInt(formData.subjectId),
        score: parseInt(formData.score),
        ismultipleAttemp: formData.ismultipleAttemp,
        id: item?.id,
        assignClasses: [
          {
            classId: 0,
            className: ''
          }
        ]
      };

      const res = await api.updateCBTSetUp(admToken, payload, item.id);

      if (res.status && res.statusCode === 2) {
        toast.success(res.message || "Setup Successfully Updated", {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        getDataCTBSetup();
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to add setup");
    } finally {
      setLoading(false);
    }
  }, [admToken, formData, user?.schoolId, getDataCTBSetup]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Choose Subject
            </InputLabel>
            <FormControl fullWidth>
              <Select
                name="subjectId"
                sx={{ fontFamily: "Gilroy-Regular" }}
                variant="outlined"
                size="small"
                value={formData.subjectId}
                onChange={handleChange}
                disabled={subjectLoading}
              >
                {subjectLoading ? (
                  <MenuItem disabled>Loading subjects...</MenuItem>
                ) : lessonSubject.length === 0 ? (
                  <MenuItem disabled>No subjects available</MenuItem>
                ) : (
                  lessonSubject.map((item) => (
                    <MenuItem
                      sx={{ fontFamily: "Gilroy-Regular" }}
                      value={item.id}
                      key={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Quiz Type
            </InputLabel>
            <FormControl fullWidth>
              <Select
                name="quizTypeId"
                sx={{ fontFamily: "Gilroy-Regular" }}
                variant="outlined"
                size="small"
                value={formData.quizTypeId}
                onChange={handleChange}
                disabled={loading}
              >
                {loading ? (
                  <MenuItem disabled>Loading quiz type...</MenuItem>
                ) : setTypes.length === 0 ? (
                  <MenuItem disabled>No quiz type available</MenuItem>
                ) : (
                  setTypes.map((type) => (
                    <MenuItem
                      sx={{ fontFamily: "Gilroy-Regular" }}
                      value={type.id}
                      key={type.id}
                    >
                      {type.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Start Date and Time
            </InputLabel>
            <TextField
              name="startDate"
              fullWidth
              size="small"
              type="datetime-local"
              value={formData.startDate}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Closing Date and Time
            </InputLabel>
            <TextField
              name="endDate"
              fullWidth
              size="small"
              type="datetime-local"
              value={formData.endDate}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Quiz / Practice Test Title
            </InputLabel>
            <TextField
              name="title"
              fullWidth
              size="small"
              value={formData.title}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Duration (in Minutes)
            </InputLabel>
            <TextField
              name="duration"
              fullWidth
              size="small"
              type="number"
              value={formData.duration}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              placeholder="e.g. 30"
            />
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Score
            </InputLabel>
            <TextField
              name="score"
              fullWidth
              size="small"
              type="number"
              value={formData.score}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              placeholder="e.g. 30"
            />
          </Box>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.ismultipleAttemp}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      ismultipleAttemp: e.target.checked,
                    }))
                  }
                  sx={{
                    color: "#671E78",
                    "&.Mui-checked": {
                      color: "#671E78",
                    },
                  }}
                />
              }
              label={
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                  }}
                >
                  Allow Multiple Attempt
                </span>
              }
            />
          </Box>
        </Grid>
      </Grid>

      <Box mt={5}>
        <Button
          variant="contained"
          fullWidth
          sx={{ textTransform: "initial" }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Set Up"}
        </Button>
      </Box>
    </Box>
  );
};

export default EditSetUp;